<div
  class="container-fluid payment-container d-flex flex-column justify-content-center align-items-center"
  [dir]="dir"
>
  @if (paymentInfo) {
    <div class="row w-100">
      <!-- Payment info Section -->
      <div class="col-md-5 offset-md-1 payment-info-section">
        <div class="p-4 payment-info">
          <div class="d-none d-sm-block">
            <img
              [src]="'assets/flyplus/app-logo.svg' | assets"
              alt="App Logo"
              class="mb-3 app-logo"
            />
          </div>
          <!-- <div class="mb-3" translate>Select card type to proceed</div> -->
          <div class="card shadow payment-info-details mb-4">
            <div class="row">
              <div class="col-sm-12">
                <div class="row">
                  <div class="col pt-2 pb-3">
                    <div class="px-3 py-2 d-flex justify-content-between">
                      <span translate>Base Price:</span>
                      <b>
                        <currency-symbol
                          [type]="paymentInfo?.currency"
                        ></currency-symbol>
                        {{
                          paymentInfo?.baseAmount?.toFixed(2) | numberTranslate
                        }}
                      </b>
                    </div>
                    @if (paymentInfo?.discountAmount) {
                      <div class="px-3 py-2 d-flex justify-content-between">
                        <span translate>Discount:</span>
                        <b class="text-danger">
                          <currency-symbol
                            [type]="paymentInfo?.currency"
                          ></currency-symbol>
                          {{
                            paymentInfo?.discountAmount?.toFixed(2)
                              | numberTranslate
                          }}
                        </b>
                      </div>
                    }
                    <div class="px-3 py-2 d-flex justify-content-between">
                      <span>{{
                        'VAT Percentage:'
                          | translate
                            : {
                                X: paymentInfo?.vatPercentage | numberTranslate,
                              }
                      }}</span>
                      <b>
                        <currency-symbol
                          [type]="paymentInfo?.currency"
                        ></currency-symbol>
                        {{
                          paymentInfo?.vatAmount?.toFixed(2) | numberTranslate
                        }}
                      </b>
                    </div>
                    <hr class="mx-3 my-2" />
                    <div class="px-3 py-2 d-flex justify-content-between">
                      <span translate class="fw-bold">Amount To Be Paid:</span>
                      <b class="fw-bold">
                        <currency-symbol
                          [type]="paymentInfo?.currency"
                        ></currency-symbol>
                        {{ paymentInfo?.amount?.toFixed(2) | numberTranslate }}
                      </b>
                    </div>
                  </div>
                </div>
                @if (holdExpiresAtMs && !isHoldExpired) {
                  <app-slot-hold-timer
                    [expiresAtMs]="holdExpiresAtMs"
                  ></app-slot-hold-timer>
                }
                @for (gateway of paymentInfo.gateways; track gateway) {
                  @if (gateway.paymentGatewayType == 3) {
                    <div class="form-col-div slot-div">
                      <!-- <mat-radio-group (change)="onCardTypeChange($event)">
                      <mat-radio-button
                        *ngFor="let card of gateway.allowedCards"
                        [value]="card"
                        >
                        <div class="card-body slot-card selected-slot">
                          <p class="slot">
                            <img
                              class="card-icon"
                              [src]="card.iconUrl"
                              alt=""
                              *ngIf="card.iconUrl"
                              />
                            <span>
                              {{ card.title }}
                            </span>
                          </p>
                        </div>
                      </mat-radio-button>
                    </mat-radio-group> -->
                      <!-- <form #paymentCashinForm method="GET" [action]="paymentCashinDetails?.formActionURL">
                    <div *ngFor="let control of paymentCashinDetails?.formContent">
                      <input type="hidden" [name]="control?.name" [value]="control?.value" />
                    </div>
                  </form> -->
                      <div class="d-flex justify-content-end mt-2 px-3">
                        <button
                          mat-flat-button
                          [disabled]="isCashinLoading || isRedirecting"
                          (click)="submitCashin()"
                          class="w-100"
                          translate
                        >
                          <div class="d-flex justify-content-center">
                            <span translate class="px-2">Proceed To Pay</span>
                            <app-loader
                              [isLoading]="isCashinLoading || isRedirecting"
                            ></app-loader>
                          </div>
                        </button>
                      </div>
                    </div>
                  }
                  <form
                    #paymentForm
                    method="POST"
                    [action]="paymentDetails?.formActionURL"
                  >
                    @for (
                      control of paymentDetails?.formContent;
                      track control
                    ) {
                      <div>
                        <input
                          type="hidden"
                          [name]="control?.name"
                          [value]="control?.value"
                        />
                      </div>
                    }
                  </form>
                  @if (gateway.paymentGatewayType == 1) {
                    <div
                      class="form-col-div slot-div px-3 py-2 d-flex justify-content-end"
                    >
                      <button
                        mat-flat-button
                        [disabled]="isLoading || isRedirecting"
                        class="w-100"
                        (click)="submit()"
                      >
                        <div class="d-flex justify-content-center">
                          <span translate class="px-2">Debit/Credit Card</span>
                          <app-loader
                            [isLoading]="isLoading || isRedirecting"
                          ></app-loader>
                        </div>
                      </button>
                    </div>
                  }
                  @if (gateway.paymentGatewayType == 2) {
                    <div
                      class="form-col-div slot-div px-3 py-2 d-flex justify-content-end"
                    >
                      @if (enableApplePay) {
                        <app-apple-pay
                          [paymentDetails]="paymentInfo"
                          [paymentId]="paymentId"
                          [isLoading]="isLoading"
                        >
                        </app-apple-pay>
                      }
                    </div>
                  }
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- success Illustration Section -->
      <div class="col-md-6 Illustration-section text-center">
        <img
          src="assets/payment-card-type.svg"
          alt=""
          class="Illustration-image mt-5"
        />
      </div>
    </div>
  }
  <div class="my-5">
    <img [src]="'assets/flyplus/powered-by.png' | assets" width="130" />
  </div>
</div>
